import React from 'react';
import { connect } from 'react-redux';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { handleLogoutUser } from 'redux/actions/auth';
import Button from 'widgets/Button';
import Icon from 'components/Icon';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import colors from 'assets/styles/jsVariables/colors';

const styles = {
  modalButtonStyle: {
    '&:hover': {
      background: `${colors.darkerCyan} !important`,
      boxShadow: 'rgba(176, 176, 176, 0.5) 0px 2px 5px 1px'
    },
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
    height: '34.45px',
    width: '142.31px',
    minHeight: '34.45px'
  },
  modalButtonLabel: {
    textTransform: 'capitalize',
    fontWeight: '600',
    fontSize: '16px'
  }
};

/**
 * A modal dialog can only be closed by selecting one of the actions.
 */
function DeleteProcessingModal(props) {
  const {
    isModalOpen,
    handleClose,
  } = props;
  return (
    <Modal
      title=""
      titleContainerStyle={{ paddingBottom: '0px' }}
      paperStyle={{
        maxWidth: 400,
        width: '80%',
        borderRadius: '10px',
      }}
      open={isModalOpen}
      childrenStyle={{
        marginRight: '0px',
        paddingLeft: '26px',
        border: '0px'
      }}
      showCross={false}
      toggleModal={handleClose}
      actions={[
        <div key="logoutButton" style={{ margin: '15px' }}>
          <Button
            variant="contained"
            color="primary"
            cssStyles={{
              root: styles.modalButtonStyle,
              label: styles.modalButtonLabel
            }}
            onClick={() => {
              props.handleLogoutUser();
            }}
          >
            <FormattedMessage id="views.dataPolicy.deleteProcessingModal.signOutButton" />
          </Button>
        </div>
        ]}
    >
      <div>
        <div style={{ paddingBottom: '19px' }}>
          <Icon
            name="alert-error"
            fill={colors.lightCyan}
            style={{
              width: '46px',
              height: '46px'
            }}
          />
        </div>
        <div style={{
          fontSize: '14px',
          color: '#7d7d7d',
          fontFamily: 'proxima_novaregular',
          lineHeight: '21px'
         }}
        >
          <FormattedHTMLMessage id="views.dataPolicy.deleteProcessingModal.description" />
          <a href="https://choosemuse.com/contactsupport" style={{ color: '#6bceed', textDecoration: 'none' }}>  https://choosemuse.com/contactsupport</a>
        </div>
      </div>
    </Modal>
  );
}

DeleteProcessingModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleLogoutUser: PropTypes.func.isRequired,
};


export default connect(null, { handleLogoutUser })(DeleteProcessingModal);



// WEBPACK FOOTER //
// ./src/views/DataPolicy/DeleteProcessingModal.jsx